import {Helpers, Providers} from "@tpd-web-common-libs/nodejs-library";
import {LocalStorageLayer, LoginService} from "@tpd-web-react-libs/nodejs-library/dist/src/providers";
import {Constants} from "@tpd-web-react-libs/nodejs-library/dist/src/common";
import {RawPolicyFromUserContext} from "@tpd-web-react-libs/nodejs-library/dist/src/interfaces";
import {CustomEventHelper} from "@tpd-web-common-libs/nodejs-library/dist/src/helpers";
import {EncryptionService} from "@tpd-web-react-libs/nodejs-library/dist/src/providers";

const URL = Constants.url[1];
const ANALYTICS_LOGIN_EVENT_ID = "unipolsai_tm_link";

export interface ClienteResponseInterface {
    compagniaPresente: boolean;
    indirizzoResidenza: boolean;
    livelloDiServizio: string;
    privacy: boolean;
    statoAccount: ClienteResponseStatoAccountEnum;
    statoDocumento: ClienteResponseStatoDocumentoEnum;
    tipo: ClienteResponseTipoEnum;
    ultimaLogin: string;
}

export enum ClienteResponseStatoAccountEnum {
    REGISTRATO = 'REGISTRATO',
    NON_REGISTRATO = 'NON_REGISTRATO'
}

export enum ClienteResponseStatoDocumentoEnum {
    VALIDATO = 'VALIDATO',
    ASSENTE = 'ASSENTE',
    DA_VALIDARE = 'DA_VALIDARE'
}

export enum ClienteResponseTipoEnum {
    PG = 'PG',
    PF = 'PF'
}

/**
 * Casi che verranno poi gestiti all'interno della pagina:
 *
 * 1. Utente deve finire la registrazione sull'altra app e mostra errore "Attenzione: Se hai iniziato la registrazione su un altro canale (es: altra App, altro sito, ...), per proseguire devi completare tutti i passaggi sullo stesso canale"
 * 2. Mostra errore "Ci dispiace, ma al momento è possibile acquistare UnipolMove aziendale solo presso una delle Agenzie UnipolSai."
 * 3. Mostra data enrichment con tanto di indirizzo di residenza solo se indirizzoResidenza == true
 *
 * @param res
 */
export const isRedirectToCompletamentoRegistrazione = (res: ClienteResponseInterface): boolean => {
    return (
        (res.tipo === ClienteResponseTipoEnum.PG &&
            res.livelloDiServizio === "WAIT_PG" &&
            res.statoAccount === ClienteResponseStatoAccountEnum.NON_REGISTRATO) ||
        (res.tipo === ClienteResponseTipoEnum.PG && !res.compagniaPresente) ||
        res.statoAccount === ClienteResponseStatoAccountEnum.NON_REGISTRATO
    );
}

export const goToRegistration = (): void => {
    if (typeof window !== "object") return;

    const url = window.location.href;
    const arrUrl = url.split("/");
    Helpers.RouterHelper.goTo([
            URL.registrazioneclienti,
            "?uri_from=",
            arrUrl[arrUrl.length - 1]
        ].join('')
    );
}

/**
 * Gestisce il redirect ad home page sul click
 */
export const goToHome = async () => {
    // SE È STATO SETTATO IL COOKIE REDIRECT, LO UTILIZZIAMO
    if (typeof document !== "object") return;

    // const cookieMap = document.cookie.split(";").map((el) => el.split("="));
    // const redirectUrlMap = cookieMap.filter(
    //     (keyValueArray) => keyValueArray[0].trim() === "redirect"
    // )[0];

    let urlToGo = URL.homepage;
    try {
        const personification = await Helpers.SessionHelper.getData(
            "_impersonification"
        );
        const isSuperUserLogged = await Helpers.SessionHelper.getData(
            "isSuperUserLogged"
          );
        if ((personification === undefined || personification === false) && isSuperUserLogged) {
            urlToGo = URL.superuser;
        }
    } catch (e) {
        console.error(
            "Errore nel recupero dell'informazione dallo storage",
            String(e)
        );
    }

    // SE NON SEI NELLA PAGINA DEL SUPERUSER, PUOI ANDARE ALLA HP AREA RISERVATA
    if (
        typeof location === "object" &&
        location.href.indexOf("home-superuser") === -1
    ) {
        Helpers.RouterHelper.goTo(urlToGo, {
            openNewTab: false,
        });
    }

    // Eliminiamo il cookie
    document.cookie = "redirect=;path=/;expires=0";
}

export const removeLeadingSpace = (text: string): string => text.trimStart();


// LOGIN / LOGOUT - START

export const logout = (): void => {
    LoginService.logoutFn().then((response) => {
        if (response && response.ok) {
            Helpers.RouterHelper.goTo("/homepage");
        }
    });
}

// LOGIN / LOGOUT - END


// ANALYTICS - START

const getAnalyticsTimestamp = (): string => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const day = today.getDate();
    const hours =
        today.getHours().toString().length < 2
            ? '0' + today.getHours()
            : today.getHours();
    const minutes =
        today.getMinutes().toString().length < 2
            ? '0' + today.getMinutes()
            : today.getMinutes();
    const seconds =
        today.getSeconds().toString().length < 2
            ? '0' + today.getSeconds()
            : today.getSeconds();
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

const buildingsDataManagement = (buildings, telematicDevice) => {
    let counter = 0;
    if (buildings.length > 0) {
        // tslint:disable-next-line: prefer-for-of
        for (let b = 0; b < buildings.length; b++) {
            counter++;
            if (telematicDevice !== "") {
                telematicDevice += "|";
            }
            telematicDevice += buildings[b].insuranceContractType;
        }
    }
    return telematicDevice;
}

const sendSendAnalytics = (
    actionName,
    actionEffect,
    userInfo,
    serviceLevel,
    userLoyaltyProgram,
    userLoyaltyScore,
    sectorPolicies,
    userCustomerType,
    email,
    agencyId,
    telematicsVehicleDeviceId,
    telematicDevice,
    userCrmId: string
) => {
    let isPartyIDCREnabled = false;
    if (Helpers.EnvironmentHelper.isClientSide()) {
        const href = window.location.href;
        if(href.includes("qa.unipolsai") ||
          href.includes("sit.unipolsai") ||
          href.includes("dev.unipolsai") ||
          href.includes("localhost")
        ){
            isPartyIDCREnabled = true;
        }
    }
    const sl = serviceLevel ? serviceLevel.level : "";
    const analyticsToSend: any = {
        action_timestamp: getAnalyticsTimestamp(),
        virtual: "action",
        action_name: actionName || "",
        action_tech: "click",
        action_type: "login",
        action_effect: actionEffect || "",
        action_element_position: "top - right",
        user_crm_id: userCrmId ? userCrmId : "",
        user_hash_cf: EncryptionService.createDigest(userInfo.customer.taxCode).toString() || "",
        user_username: userInfo.username || "",
        user_email: email || "",
        user_type: userInfo.registry.type === Constants.typePersona.personaFisica ? "P" : "I",
        user_segment: userInfo.registry.feaAuthorizationFlag == true ? "Fea" : "NoFea",
        user_category1: userInfo.policies.length > 0 ? userInfo.policies.length == 1 ? "monopolizza" : "multipolizza" : "",
        user_category2: sectorPolicies || "",
        ...(!isPartyIDCREnabled && { user_party_id: userInfo.partyId || "" }),
        user_service_level: sl || "",
        user_customer_type: userCustomerType || "",
        user_pension_flag:
            userInfo.policies.filter((policy: RawPolicyFromUserContext) => {
                return policy.agreementSystem === "CDH_PREVIDENZA";
            })?.length > 0,
        user_privacy_level: userInfo.registry.commercialPrivacy || "",
        user_loyalty_program: userLoyaltyProgram ? "1" : "0",
        user_loyalty_score:
            userLoyaltyScore &&
            userLoyaltyScore != "" &&
            parseInt(userLoyaltyScore) > 0
                ? userLoyaltyScore.toString()
                : "0",
        user_agency_id: agencyId || "",
        telematics_vehicle_device_id: telematicsVehicleDeviceId || "",
        telematics_devices: telematicDevice || "",
        user_sia_login: LoginService.hasSiaAgency, // TODO: controllare il funzionamento della variabile hasSiaAgency (probabilmente non serve)
    };
    const analyticsService = Providers.AnalyticsService.getInstance();
                analyticsService.triggerLink(analyticsToSend);
}

export const sendAnalytics = (
    actionName,
    actionEffect,
    userInfo,
    serviceLevel,
    userLoyaltyProgram,
    userLoyaltyScore
): void => {
    let email = "";
    if (userInfo.registry && userInfo.registry.contactInformations) {
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < userInfo.registry.contactInformations.length; i++) {
            // tslint:disable-next-line: triple-equals
            if (
                userInfo.registry.contactInformations[i].type == 4 ||
                // tslint:disable-next-line: triple-equals
                userInfo.registry.contactInformations[i].type == "4"
            ) {
                email = userInfo.registry.contactInformations[i].value;
            }
        }
    }
    let agencyId = "";
    if (userInfo.registry && userInfo.registry.contactInformationsAgencies) {
        if (userInfo.registry.contactInformationsAgencies.length > 0) {
            agencyId = userInfo.registry.contactInformationsAgencies[0].agencyKey;
        }
    }
    let telematicsVehicleDeviceId = "";
    let telematicDevice = "";
    if (userInfo.allTelematicContracts) {
        if (userInfo.allTelematicContracts.auto) {
            const auto = userInfo.allTelematicContracts.auto;
            // tslint:disable-next-line: prefer-for-of
            for (let a = 0; a < auto.length; a++) {
                if (telematicsVehicleDeviceId !== "") {
                    telematicsVehicleDeviceId += "|";
                }
                telematicsVehicleDeviceId += auto[a].telematicDevice.deviceType;
            }
        }
        if (userInfo.allTelematicContracts.home) {
            telematicDevice = buildingsDataManagement(
                userInfo.allTelematicContracts.home,
                telematicDevice
            );
        }
        if (userInfo.allTelematicContracts.building) {
            telematicDevice = buildingsDataManagement(
                userInfo.allTelematicContracts.building,
                telematicDevice
            );
        }
        if (userInfo.allTelematicContracts.factory) {
            telematicDevice = buildingsDataManagement(
                userInfo.allTelematicContracts.factory,
                telematicDevice
            );
        }
        if (userInfo.allTelematicContracts.condominio) {
            telematicDevice = buildingsDataManagement(
                userInfo.allTelematicContracts.condominio,
                telematicDevice
            );
        }
        if (userInfo.allTelematicContracts.albergo) {
            telematicDevice = buildingsDataManagement(
                userInfo.allTelematicContracts.albergo,
                telematicDevice
            );
        }
    }
    let sectorPolicies = "";
    let familyIds = "";
    if (userInfo && userInfo.policies) {
        if (userInfo.policies.length > 0) {
            const policies = userInfo.policies;
            const l = userInfo.policies.length;
            const firstFamilyId = userInfo.policies[0].familyId;
            const familyIdsArray = [];
            sectorPolicies = "monosettore";
            for (let p = 0; p < l; p++) {
                familyIdsArray.push(policies[p].familyId);
                if (policies[p].familyId !== firstFamilyId) {
                    sectorPolicies = "multisettore";
                }
            }
            const unique = familyIdsArray.filter((v, i, a) => a.indexOf(v) === i);
            // tslint:disable-next-line: prefer-for-of
            for (let f = 0; f < unique.length; f++) {
                if (familyIds !== "") {
                    familyIds += "|";
                }
                familyIds += unique[f];
            }
        }
    }

    const localStorageLayerService = new LocalStorageLayer();
    localStorageLayerService.getProspect()
        .then((response) => {
            let userCustomerType = "";
            switch (response.classification) {
                case "0":
                    userCustomerType = "prospect online";
                    break;
                case "1":
                    userCustomerType = "prospect agenzia";
                    break;
                case "2":
                    userCustomerType = "cliente";
                    break;
                default:
                    userCustomerType = "tipo cliente non identificato";
                    break;
            }

            Helpers.SessionHelper.getData("user_crm_id")
                .then((userCrmId) => {
                    sendSendAnalytics(
                        actionName,
                        actionEffect,
                        userInfo,
                        serviceLevel,
                        userLoyaltyProgram,
                        userLoyaltyScore,
                        sectorPolicies,
                        userCustomerType,
                        email,
                        agencyId,
                        telematicsVehicleDeviceId,
                        telematicDevice,
                        userCrmId
                    );
                })
                .catch((e) => {
                    sendSendAnalytics(
                        actionName,
                        actionEffect,
                        userInfo,
                        serviceLevel,
                        userLoyaltyProgram,
                        userLoyaltyScore,
                        sectorPolicies,
                        userCustomerType,
                        email,
                        agencyId,
                        telematicsVehicleDeviceId,
                        telematicDevice,
                        ""
                    );
                });
        })
        .catch((err) => {
            console.log(err);
        });
}

// ANALYTICS - END
